export default __webpack_public_path__ + "static/media/bg-login.62123411.png";